import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const TermsOfService = () => {
  return (
    <Box sx={{ p: 3, maxWidth: '900px', mx: 'auto' }}>
      <Typography
        variant="h4"
        component="h1"
        gutterBottom
        sx={{
          fontWeight: 700,
          mb: 4,
          textAlign: 'center',
          color: 'primary.main'
        }}
      >
        Terms of Service
      </Typography>

      <Paper
        elevation={2}
        sx={{
          p: 4,
          borderRadius: 2,
          backgroundColor: 'background.paper',
          '& h2': {
            fontSize: '1.5rem',
            fontWeight: 600,
            mt: 4,
            mb: 2,
            color: 'text.primary'
          },
          '& p': {
            mb: 2,
            lineHeight: 1.6,
            color: 'text.primary'
          },
          '& ul, & ol': {
            mb: 2,
            pl: 3
          },
          '& li': {
            mb: 1,
            lineHeight: 1.5
          }
        }}
      >
        <Typography variant="h2">1. Acceptance of Terms</Typography>
        <Typography variant="body1">
          Welcome to Dhandhapaani. By accessing or using Dhandhapaani web or mobile
          services, you agree to these Terms of Service. If you do not agree, do not
          use the Service.
        </Typography>

        <Typography variant="h2">2. Service Scope</Typography>
        <Typography variant="body1">
          Dhandhapaani provides business operations features such as sales, purchases,
          inventory, customer management, expenses, analytics, and invoicing. Features
          may evolve over time.
        </Typography>

        <Typography variant="h2">3. Accounts and Security</Typography>
        <Typography variant="body1">
          You are responsible for maintaining account confidentiality and all activity
          under your account. You must provide accurate registration/business details
          and notify us if you suspect unauthorized access.
        </Typography>

        <Typography variant="h2">4. Data and Processing</Typography>
        <Typography variant="body1">
          Your business data is processed and stored through Dhandhapaani backend
          systems and databases. Google Sign-In may be used for authentication.
          You are responsible for the legality, accuracy, and permissions for the data
          you enter into the Service.
        </Typography>

        <Typography variant="h2">5. Acceptable Use</Typography>
        <Typography variant="body1">You agree not to:</Typography>
        <ul>
          <li>Use the Service for unlawful, fraudulent, or abusive activity.</li>
          <li>Attempt unauthorized access, reverse engineering, or data scraping.</li>
          <li>Upload malicious code or interfere with platform operation.</li>
          <li>Infringe intellectual property or privacy rights of others.</li>
        </ul>

        <Typography variant="h2">6. Availability and Changes</Typography>
        <Typography variant="body1">
          We may modify, suspend, or discontinue any part of the Service, including
          features, integrations, and limits, with or without notice. We may also
          perform maintenance that temporarily impacts availability.
        </Typography>

        <Typography variant="h2">7. Termination</Typography>
        <Typography variant="body1">
          We may suspend or terminate access if these Terms are violated, for security
          reasons, or when required by law. You may stop using the Service at any time.
        </Typography>

        <Typography variant="h2">8. Disclaimer and Limitation of Liability</Typography>
        <Typography variant="body1">
          The Service is provided on an &quot;as is&quot; and &quot;as available&quot;
          basis. To the maximum extent permitted by law, we disclaim warranties and are
          not liable for indirect, incidental, special, consequential, or punitive
          damages, including loss of profits, data, or business interruption.
        </Typography>

        <Typography variant="h2">9. Governing Law</Typography>
        <Typography variant="body1">
          These Terms are governed by the laws of India. Courts in Neemuch, Madhya Pradesh,
          India will have jurisdiction, subject to applicable law.
        </Typography>

        <Typography variant="h2">10. Contact</Typography>
        <Typography variant="body1">
          For legal or terms-related questions, please contact us:
        </Typography>
        <ul>
          <li>Email: patidarp21@gmail.com</li>
          <li>Address: Neemuch</li>
          <li>Phone: 7089113323</li>
        </ul>

        <Typography variant="body1" sx={{ mt: 4, fontStyle: 'italic' }}>
          Last updated: February 27, 2026
        </Typography>
      </Paper>
    </Box>
  );
};

export default TermsOfService;


